<template>
  <main class="bg-white pt-24 pb-20 px-4">
    <article class="max-w-3xl mx-auto">
      <h1 class="text-4xl font-bold tracking-tight mb-2" style="color: var(--color-krate-dark-900);">Terms of Service</h1>
      <p class="text-sm mb-8" style="color: var(--color-krate-dark-500);">Last updated: 2026-04-30</p>

      <p style="color: var(--color-krate-dark-700);">These terms apply to your use of the krate beta — both the hosted services at <a href="https://krate.sh" class="underline" style="color: var(--color-krate-blue-600);">krate.sh</a> and <a href="https://app.krate.sh" class="underline" style="color: var(--color-krate-blue-600);">app.krate.sh</a> and the CLI you install on your own machine.</p>

      <h2 class="text-xl font-semibold mt-8 mb-3" style="color: var(--color-krate-dark-900);">Beta status</h2>
      <p style="color: var(--color-krate-dark-700);">
        krate is in beta. Things may break. We may change features, pause the service, or wipe your beta data with reasonable notice. We're working hard not to do any of that.
      </p>

      <h2 class="text-xl font-semibold mt-8 mb-3" style="color: var(--color-krate-dark-900);">Acceptable use</h2>
      <p style="color: var(--color-krate-dark-700);">
        Don't use krate to host illegal content, send spam, attack other systems, or do anything that breaks applicable law. We reserve the right to revoke access if we find out you're doing any of those things.
      </p>

      <h2 class="text-xl font-semibold mt-8 mb-3" style="color: var(--color-krate-dark-900);">Open source</h2>
      <p style="color: var(--color-krate-dark-700);">
        The CLI is licensed under its respective license (see the public repos at <a href="https://github.com/krate-dot-sh" class="underline" style="color: var(--color-krate-blue-600);">github.com/krate-dot-sh</a>). These terms govern the hosted services we run; the open-source license governs the source code.
      </p>

      <h2 class="text-xl font-semibold mt-8 mb-3" style="color: var(--color-krate-dark-900);">No warranty</h2>
      <p style="color: var(--color-krate-dark-700);">
        The beta is provided as-is, without warranty. We don't promise it will be uninterrupted, error-free, or fit for any particular purpose. Use it at your own risk during the beta.
      </p>

      <h2 class="text-xl font-semibold mt-8 mb-3" style="color: var(--color-krate-dark-900);">Contact</h2>
      <p style="color: var(--color-krate-dark-700);">
        Questions: <a href="mailto:hello@krate.sh" class="underline" style="color: var(--color-krate-blue-600);">hello@krate.sh</a>.
      </p>
    </article>
  </main>
</template>
